import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionProducto} from '../../../../actions/action-creators'
import TablaFacturacionCRE from '../GeneracionFactura/TablaFacturacionCRE'

const CRETablaResumen = () => {
  const documentosAsociados = useSelector((state: State) => state.comprobanteRetencion.documentosAsociados)
  const calculos = useSelector((state: State) => state.comprobanteRetencion.calculosArrayProductos)
  const dispatch = useDispatch()
  const {comprobanteRetencionCalculoTotalArrayProducto} = bindActionCreators(actionComprobanteRetencionProducto, dispatch)

  useEffect(() => {
    comprobanteRetencionCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentosAsociados])

  return (
    <div className='w-layout-vflex card-content'>
      <TablaFacturacionCRE documentos={documentosAsociados} datos={calculos} sinAcciones={true} />
    </div>
  )
}

export default CRETablaResumen
